module.exports = __webpack_public_path__ + "public/images/Illustration_Math_200x174.a6c5c1fb2e784d2ade79cd06c92c9245.png";